import { lazy } from "react"

export const CLASH_OF_DIGGERS_MODALS = {
  clashOfDiggersBetaTest: {
    component: lazy(
      () => import("modals/ui/clashOfDiggers/ClashOfDiggersBetaTestModal")
    )
  }
} as const
